<div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h3 class="m-0 font-weight-bold" style="color: #1A355E;">MÜŞTERİ TERMİNAL ATAMASI</h3>
        <ol class="breadcrumb ">
            <li class="breadcrumb-item active">Hareketler</li>
            <li class="breadcrumb-item active">Müşteri Terminal Ataması</li>
        </ol>
    </div>
    <div class="data-grid">
        <p-table #dt [value]="customerTerminals$ | async" [paginator]="true" [rows]="25" [showCurrentPageReport]="true"
            styleClass="p-datatable-sm" [rowHover]="true"
            currentPageReportTemplate="{totalRecords} veriden {first} - {last} gösteriliyor.."
            [globalFilterFields]="['projectName','customerName','serviceName','portalName','contractTypeName','contractNumber','numberOfTerminals']"
            [responsive]="true" [rowsPerPageOptions]="[5,10,25,50]">
            <ng-template pTemplate="caption">
                <button pButton type="button" class="p-button-info" label="Yeni"
                    routerLink="/customer-terminal-add"></button>
                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2" pTooltip="Dışa Aktar" tooltipPosition="bottom"
                    label="Dışa Aktar"></button>
                <div style="text-align: right">
                    <input style="float:right" type="text" pInputText size="50" placeholder="Ara"
                        (input)="applyFilterGlobal($event, 'contains')" style="width:auto">
                </div>

                <div class="text-center" *ngIf="loading">
                    <div class="spinner-grow text-primary" style="width: 3rem; height: 3rem;" role="status">
                    </div>
                    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;" role="status">
                    </div>
                    <div class="spinner-grow text-secondary" style="width: 3rem; height: 3rem;" role="status">
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="customerName" [width]="'20%'">Müşteri<p-sortIcon field="customerName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="projectName" [width]="'20%'">Proje<p-sortIcon field="projectName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="portalName" [width]="'10%'">Portal<p-sortIcon field="portalName">
                        </p-sortIcon>
                    </th>

                    <th pSortableColumn="serviceName" [width]="'15%'">Hizmet<p-sortIcon field="serviceName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="serviceUnitPrice" [width]="'15%'">Hizmet Birim Fiyatı<p-sortIcon
                            field="serviceUnitPrice">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="numberOfTerminals" [width]="'10%'">Terminal Sayısı<p-sortIcon
                            field="numberOfTerminals">
                        </p-sortIcon>
                    </th>

                    <th [width]="'10%'">

                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-customerTerminals>
                <tr>
                    <td>{{customerTerminals.customerName}}</td>
                    <td>{{customerTerminals.projectName}}</td>
                    <td>{{customerTerminals.portalName}}</td>
                    <td>{{customerTerminals.serviceName}}</td>
                    <td>{{customerTerminals.serviceUnitPrice| number: '1.0'}} {{customerTerminals.currencyUnit}}</td>
                    <td> <span class="badge badge-dark"
                            style="font-size: 1.5rem;">{{customerTerminals.numberOfTerminals}}</span></td>

                    <td>
                        <button pButton pRipple type="button" icon="pi pi-pencil"
                            class="p-button-rounded p-button-success" pTooltip="Güncelle" tooltipPosition="bottom"
                            routerLink="/customer-terminal-update/{{customerTerminals.id}}"></button>
                        <button pButton pRipple type="button" icon="pi pi-trash"
                            class="p-button-rounded p-button-danger" pTooltip="Sil" tooltipPosition="bottom"
                            (click)="showDeleteModal(customerTerminals.id)"></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<p-dialog header="MÜŞTERİ TERMİNAL SİL" [(visible)]="deleteModal" [modal]="true" [style]="{width: '50vw'}"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <p class="p-m-0">Terminal ataması silinecek. Bağlı terminaller havuza gönderilecek. Onaylıyor musunuz?</p>
    <ng-template pTemplate="footer">
        <p-button (click)="deleteModal=false" label="Vazgeç" styleClass="p-button-dark"></p-button>
        <p-button (click)="deleteCustomerTerminal()" label="Sil" styleClass="p-button-danger"></p-button>
    </ng-template>
</p-dialog>